import { render, staticRenderFns } from "./switch_level.vue?vue&type=template&id=086099a1&scoped=true"
import script from "./switch_level.vue?vue&type=script&lang=js"
export * from "./switch_level.vue?vue&type=script&lang=js"
import style0 from "./switch_level.vue?vue&type=style&index=0&id=086099a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086099a1",
  null
  
)

export default component.exports